import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const apiKey = "4ebb6c8a-a9b6-4cb6-ac38-1765cd00ff4a";

// redux/createApi.js
export const automotorApi = createApi({
  reducerPath: "automotorApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://api.apicar.store/api/",
    prepareHeaders: (headers) => {
      headers.set("api-key", apiKey);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCars: builder.query({
      query: ({ page = 1, size = 10, make = "", site = "" }) => {
        const url = `cars?page=${page}&size=${size}${make !== "" ? `&make=${make}` : ""}${site !== "" ? `&site=${site}` : ""
          }`;
        return url;
      },
    }),
    getCarsFilter: builder.query({
      query: ({ page = 1, size = 10, make = "", vehicle_type = "", country = "" }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          size: size.toString(),
        });

        if (make) params.append("make", make);
        if (vehicle_type) params.append("vehicle_type", vehicle_type);
        if (country) params.append("country", country);

        return `cars?${params.toString()}`;
      },
    }),
    getCarsFilterTab: builder.query({
      query: ({ page = 1, size = 10, vehicle_type = "" }) => {
        const url = `cars?page=${page}&size=${size}&vehicle_type=${vehicle_type}`;
        return url;
      },
    }),
  }),
});

export const {
  useGetCarsQuery,
  useGetCarsFilterQuery,
  useGetCarsFilterTabQuery,
} = automotorApi;
